<div class="map">
    <google-map
        width="100%"
        #googleMap
        [zoom]="zoom"
        [center]="center"
        [options]="options">
        @if (viewNearLines) {
            @for (nl of viewNearLines; track $index) {
                <map-polygon [paths]="nl.wgsPoints"
                             (polygonClick)="polyClick(nl)"
                             title="test"
                             [options]="{zIndex: 999, strokeColor: '#00ffff',fillColor: '#00ffff', strokeOpacity: 0.8, fillOpacity: 0.1, strokeWeight: 2}"
                />
            }
        }
        @if (viewNearLines) {
            @for (nl of textPolygons; track $index) {
                <map-polygon [paths]="nl['geometry'] | convertPolygon"
                             (polygonClick)="polyClick(nl)"
                             title="test"
                             [options]="{strokeColor: '#ffc400',fillColor: '#fff200', strokeOpacity: 0.8, fillOpacity: 0.1, strokeWeight: 2}"
                />
            }
        }
        @if (outlinePoly) {
            <map-polygon [paths]="outlinePoly['geometry'] | convertPolygon"
                         title="test"
                         [options]="{strokeColor: '#220045',strokeOpacity: 0.8, strokeWeight: 2}"
            />
            @for (pp of (outlinePoly['geometry'] | convertGeometry); track $index; let i = $index) {
                <map-advanced-marker
                    [position]="{ lat: pp.lat, lng: pp.lng }"
                />
            }
            @for (pp of (outlinePoints); track i; let i = $index) {
                <map-advanced-marker
                    title="{{pp.properties.handle}}"
                    [position]="{ lat: pp.geometry.coordinates[0], lng: pp.geometry.coordinates[1] }"
                />
            }
        }
        @if (showMap) {

            @if (showMap.bord['rotLine']) {
                <map-polyline
                    [options]="{strokeWeight:5, strokeOpacity:0.3, strokeColor: '#990099'}"
                    [path]="showMap.bord['rotLine']['geometry'] | convertGeometry"/>
            }
            @if (showMap.bord['rotLine2']) {
                <map-polyline
                    [options]="{strokeWeight:5, strokeOpacity:0.3, strokeColor: '#096609'}"
                    [path]="showMap.bord['rotLine2']['geometry'] | convertGeometry"/>
            }
            @if (showMap.bord['rotLine3']) {
                <map-polyline
                    [options]="{strokeWeight:5, strokeOpacity:0.3, strokeColor: '#220045'}"
                    [path]="showMap.bord['rotLine3']['geometry'] | convertGeometry"/>
            }
            @if (showMap.bord['rotLine4']) {
                <map-polyline
                    [options]="{strokeWeight:5, strokeOpacity:1, strokeColor: '#ff0000'}"
                    [path]="showMap.bord['rotLine4']['geometry'] | convertGeometry"/>
            }
            @if (showMap.bord['lineMid']) {
                <map-polyline
                    [options]="{strokeWeight:5, strokeOpacity:0.3, strokeColor: '#096609'}"
                    [path]="showMap.bord['lineMid']['geometry'] | convertGeometry"/>
            }

            <!--<map-polygon [paths]="showMap.bord['polygon']['geometry'] | convertPolygon"
                         title="test"
                         [options]="{strokeColor: '#ff0045',fillColor: '#ff0000', strokeOpacity: 1, strokeWeight: 2}"
            />-->

            <map-advanced-marker
                #markerElem="mapAdvancedMarker"
                [position]="{ lat: showMap.bord.lat, lng: showMap.bord.lng }"
                [title]="showMap.bord.name + ' (bord zelf)'"
            />
            @for (bord of showMap.firstLines; track $index; let i = $index) {
                <map-polygon [paths]="bord.wgsPointsPolygon"
                             (polygonClick)="polyClick(bord)"
                             [options]="{strokeColor: '#00FF00',strokeOpacity: 0.8, strokeWeight: 2}"
                />
                @if (showMap.connections && showMap.connections[i]?.length) {
                    @for (b of showMap.connections[i]; track $index) {
                        <map-polygon
                            *ngIf="b.wgsPointsPolygon?.length"
                            (polygonClick)="polyClick(b)"
                            [paths]="b.wgsPointsPolygon"
                            [options]="{strokeColor: '#FF0000',strokeOpacity: 0.4, strokeWeight: 2, fillColor: '#FF0000', fillOpacity: 0.00}"/>
                    }
                }

                @if (showMap.parentInsert) {
                    <map-advanced-marker
                        #markerElem="mapAdvancedMarker"
                        [position]="{ lat: showMap.parentInsert.lat, lng: showMap.parentInsert.lng }"
                        [title]="showMap.parentInsert.name + ' parentinsert'"
                    />
                }
            }
            @if (showMap.parent?.length) {
                @for (b of showMap.parent; track i; let i = $index) {
                   <!-- @for (pp of (b.wgsPoints); track ii; let ii = $index) {
                        <map-advanced-marker
                            [position]="{ lat: pp.lat, lng: pp.lng }"
                        />
                    }-->
                    <map-polygon
                        *ngIf="b.wgsPointsPolygon?.length"
                        (polygonClick)="polyClick(b)"
                        [title]="b.handle"
                        [paths]="b.wgsPointsPolygon"
                        [options]="{strokeColor: '#0000FF',strokeOpacity: 0.5, strokeWeight: 1, fillColor: '#0000FF', fillOpacity: 0.025}"/>
                }
            }
            @if (showMap.otherPoints) {
                @for (otherPoint of showMap.otherPoints; track i; let i = $index) {
                    <map-advanced-marker
                        *ngIf="otherPoint?.lat"
                        #markerElem="mapAdvancedMarker"
                        [position]="{ lat: otherPoint.lat, lng: otherPoint.lng }"
                        [title]="otherPoint.handle + ' other'"
                    />
                }
            }
            @if (showMap.location) {
                <map-advanced-marker
                    #markerElem="mapAdvancedMarker"
                    [position]="{ lat: showMap.location.lat, lng: showMap.location.lng }"
                    [title]="showMap.location.handle + 'location'"
                />
            }
        }
    </google-map>
</div>
<div class="data">
    <div *ngFor="let bord of data;" [class.active]="bord.bord?.handle === showMap?.bord?.handle">
        <div>
            <button (click)="showPoly(bord.bord)">
                json
            </button>
        </div>
        <div class="bord">
            <div (click)="showOnMap(bord)">
                {{bord.text}}
            </div>
            <div>
                <div *ngFor="let c of bord.firstLines" (click)="showOnMapConn(bord, c.parent_handle)">
                    > {{c.handle}} parent: [{{c.parent_handle}}]
                    @if (bord.location?.handle) {
                        <b>has location:</b> [{{bord.location?.handle}}]
                    }
                </div>
            </div>
        </div>

    </div>
    <div>
        <button (click)="writeToEntitiesDb()">Write to entities DB</button>
    </div>
</div>
